var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"83px"}},[_c('div',{staticClass:"TSDN-title"},[_vm._v("关于Amazon SEND（亚马逊跨境承运伙伴方案）")]),_c('div',{staticClass:"TSDN-content"},[_vm._v(" Amazon SEND（亚马逊跨境承运伙伴方案），指由亚马逊筛选的物流合作承运人将卖家货件从中国发往目的国的亚马逊运营中心，为卖家提供了从上门取货到完成送仓一站式集成服务，全程可以在卖家平台完成并追踪，减少运营成本的同时也让卖家更安心。 ")])])])
}]

export { render, staticRenderFns }